import { createORPCClient } from "@orpc/client"
import { RPCLink } from "@orpc/client/fetch"
import type { RouterClient } from "@orpc/server"
import type { trackRouter } from "../../../../track/src/modules/track/track.rpc"

// 从环境变量获取 Track 服务地址
const TRACK_API_URL = `${process.env.NEXT_PUBLIC_TRACK_URL || "https://beta-hmt-track.popmart.com"}/rpc`

// Track 服务的 oRPC 客户端类型
export type TrackORPCClient = RouterClient<{ track: typeof trackRouter }>

/**
 * 获取专门为埋点服务配置的 oRPC 客户端实例
 * @returns {TrackORPCClient} 埋点服务的 oRPC 客户端实例
 */
export function getTrackORPCClient(): TrackORPCClient {
	return createORPCClient(
		new RPCLink({
			url: TRACK_API_URL,
			headers: () => {
				return {
					"Content-Type": "application/json",
					Accept: "application/json",
				}
			},
			fetch: (input, init) => {
				return fetch(input, {
					...init,
					// 埋点请求不需要包含 cookies，避免跨域问题
					credentials: "omit",
				})
					.then(async (res) => {
						// 尝试解析响应内容
						const resClone = res.clone()
						let data: any = null

						try {
							data = await resClone.json()
						} catch {
							// 无法解析 JSON 的情况
							if (!res.ok) {
								throw {
									json: {
										code: res.status,
										message: res.statusText || `HTTP ${res.status} 错误`,
									},
									status: res.status,
									statusText: res.statusText,
								}
							}
							return res
						}

						// 成功解析了 JSON 内容
						if (res.ok) {
							return new Response(JSON.stringify(data), {
								status: res.status,
								statusText: res.statusText,
								headers: res.headers,
							})
						}

						return res
					})
					.catch((error) => {
						console.error("Track orpc fetch error", error)
						throw error
					})
			},
		}),
	)
}

// 创建单例实例
let trackORPCClientInstance: TrackORPCClient | null = null

/**
 * 获取埋点服务的 oRPC 客户端单例
 * @returns {TrackORPCClient} 埋点服务的 oRPC 客户端单例
 */
export function getTrackORPCClientInstance(): TrackORPCClient {
	if (!trackORPCClientInstance) {
		trackORPCClientInstance = getTrackORPCClient()
	}
	return trackORPCClientInstance
}
